import { z } from 'zod';
import i18n from '@/core/i18n/config';

export function setupZodErrorMap() {
    z.config({
        customError: (iss) => {
            return i18n.t('common:errors.invalid_field', {
                defaultValue: iss.message ?? 'Invalid field',
            });
        },
    });
}